import { render, staticRenderFns } from "./AcceptanceStatusBadge.vue?vue&type=template&id=22717178"
import script from "./AcceptanceStatusBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./AcceptanceStatusBadge.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AcceptanceStatusBadge.vue?vue&type=style&index=0&id=22717178&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports